import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Moon, Sun } from "lucide-react";
import { Logo } from "@/components/atas/Logo";
import { useTheme } from "@/lib/theme";
import { useMe } from "@/lib/me";

const ThemeToggle = () => {
  const { isDark, toggle } = useTheme();
  return (
    <button onClick={toggle} data-testid="theme-toggle" aria-label="Tukar tema"
      className="h-10 w-10 hidden sm:grid place-items-center rounded-full border border-line text-mute hover:text-ink hover:bg-surface transition-colors">
      {isDark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
};

const navCls = ({ isActive }) => `inline-flex px-2 sm:px-3 h-10 items-center rounded-full text-sm whitespace-nowrap ${isActive ? "text-ink bg-surface border border-line" : "text-mute hover:text-ink"}`;

const AdminLink = () => {
  const me = useMe();
  if (me?.role !== "superadmin") return null;
  return <NavLink to="/admin" data-testid="nav-admin-link" className={navCls}>Admin</NavLink>;
};

const BalancePill = () => {
  const me = useMe();
  if (!me?.akaun) return null;
  const un = me.role === "superadmin";
  return (
    <Link to="/akaun" data-testid="nav-balance-pill" title="Baki carian"
      className="h-10 px-2 sm:px-3 inline-flex items-center gap-1.5 rounded-full border border-line text-sm hover:bg-surface transition-colors">
      <span className="font-mono-data text-q">{un ? "∞" : me.akaun.jumlah_baki}</span><span className="hidden md:inline text-mute">carian</span>
    </Link>
  );
};

export const AppShell = ({ children }) => (
  <div className="grain min-h-screen relative">
    <header className="relative z-10 border-b border-line/80 backdrop-blur-md sticky top-0" style={{ background: "color-mix(in srgb, var(--bg) 85%, transparent)" }}>
      <div className="max-w-6xl mx-auto px-3 sm:px-8 h-16 flex items-center justify-between gap-2">
        <Link to="/" data-testid="nav-home-link" className="pt-1"><Logo /></Link>
        <nav className="flex items-center gap-0.5 sm:gap-3 min-w-0">
          <Show when="signed-in">
            <NavLink to="/program" data-testid="nav-program-link" className={navCls}>Program</NavLink>
            <NavLink to="/hte" data-testid="nav-hte-link" className={navCls}>Kaji<span className="hidden sm:inline">&nbsp;Ayat</span></NavLink>
            <NavLink to="/kajian" data-testid="nav-kajian-link" className={navCls}>Ruang<span className="hidden sm:inline">&nbsp;Kerja</span></NavLink>
            <AdminLink />
            <BalancePill />
          </Show>
          <ThemeToggle />
          <Show when="signed-out">
            <Link to="/sign-in" data-testid="nav-signin-button"
              className="h-10 px-5 inline-flex items-center rounded-full bg-ink text-bg text-sm font-semibold hover:opacity-90 transition-opacity">Log masuk</Link>
          </Show>
          <Show when="signed-in"><div data-testid="user-menu"><UserButton /></div></Show>
        </nav>
      </div>
    </header>
    <main className="relative z-[1]">{children}</main>
    <footer className="relative z-[1] max-w-6xl mx-auto px-4 sm:px-8 py-10 text-xs text-mute font-mono-data">
      HTE · Heaven To Earth · ATAS — Associate Trainer Akademi Sinergi
    </footer>
  </div>
);
